// 定义一些常量

/** 上报事件，BC段 */
export const BI_TAGS =  {
  bc1: 'common_banner.banner',
};

